import {
  LightbulbOutlineIcon,
  GasIcon,
  HotwaterIcon,
  LpgIcon,
  IIconProps,
} from '@origin-digital/icon';
import { IDivisionId } from '@origin-digital/formatters';
import { DivisionCodeEnum } from '@origin-digital/shared-app-context';
import { IDivisionCode } from '@origin-digital/shared-app-context/dist/typings/generated/api/models';

export const contextHubKey = 'ContextHubPersistence';

export const trackingAppId = 'unauthenticated:bill-payment';
export const trackingAppIdAuth = 'authenticated:bill-payment';

export const dateFormat = 'dd MMM yy';

export const authenticationCookie = 'is-logged-in';

export const invoiceIdMatch = '([abpABP]/\\d{3,}|\\d{3,})?';
export const recaptchaUrlMatch = 'recaptcha/api2/bframe';
export const invalidRedirectParam = 'invalidRedirect';

export const apiBasePaths = {
  billingPayment: '/my-account/billing-payment/api/v1',
  dashboard: '/my-account/dashboard/api/v1',
  payment: '/api/payment/v1',
  paymentMethods: '/api/payment-methods',
};

export const apiPaths = {
  authType: '/verify/api/v2/accounts/:accountNumber/types?recaptcha=:recaptcha',
  krakenPayment: ':krakenUrl/v1/accounts/:accountNumber/payments/ad-hoc/',
};

export const routes = {
  base: `/:invoiceId${invoiceIdMatch}`,
  confirm: '/confirm',
  selectContractAccount: '/select-contract-account',
  selectPaymentMethod: '/select-payment-method',
  success: '/success',
};

export const lpgDivisionId = '11'; // Symbolic
export const lpgDivisionCode = DivisionCodeEnum.LPG; // Symbolic

export type IDivisionIdWithLpg = IDivisionId | typeof lpgDivisionId;

export const divisionCodeMap: { [key in IDivisionCode]: IDivisionIdWithLpg } = {
  ELECTRICITY: '01',
  NATURAL_GAS: '02',
  HOT_WATER: '03',
  LPG: lpgDivisionId,
};

export const divisionIdLabelMap: { [key in IDivisionIdWithLpg]: string } = {
  '01': 'Electricity',
  '02': 'Natural gas',
  '03': 'Hot water',
  [lpgDivisionId]: 'LPG',
};

export const divisionIdIconMap: {
  [key in IDivisionIdWithLpg]: React.FunctionComponent<IIconProps>
} = {
  '01': LightbulbOutlineIcon,
  '02': GasIcon,
  '03': HotwaterIcon,
  [lpgDivisionId]: LpgIcon,
};

export const webMboxes = {
  NBA_CARD_WEB: 'OE-461-mbox',
  INTERSTITIAL_WEB: 'interstitial-payment-confirmation-web',
};

export const appMboxes = {
  NBA_CARD_APP: 'OE-468-mbox',
  INTERSTITIAL_APP: 'interstitial-payment-confirmation-app',
};
